import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3145919c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "signable-documents-modal-content" }
const _hoisted_2 = { class: "date-cell" }

import { computed, inject, ref, watch } from "vue";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import GridBase from "@/components/ui/grid/grid-base.vue";
import { DxColumn } from "devextreme-vue/data-grid";
import { DxToolbarItem } from "devextreme-vue/popup";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import { SignableHistoryItem } from "@/types/signable-documents/SignableHistoryItem";
import displayErrorMessage from "@/utils/ErrorHandling";
import { formatDate } from "bright-logic-core/src/format";


export default /*#__PURE__*/_defineComponent({
  __name: 'signable-document-history-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The synckey to fetch signable documents history.
   * @type String
   * @required
   */
  synckey: {
    type: String,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes.
   * Used to sync the modal open/close state with the parent component via v-model.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;




const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const apiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const dataLoading = ref(false);
const historyData = ref<SignableHistoryItem[]>([]);

watch(
  () => showModal.value,
  async () => {
    if (!showModal.value) {
      return;
    }
    await fetchSignableDocumentsHistory();
  },
);

const fetchSignableDocumentsHistory = async () => {
  dataLoading.value = true;
  try {
    historyData.value = await apiClient.httpGet(
      `app/signable/GetDocumentHistory/${props.synckey}`,
    );
    if (historyData.value.length > 0) {
      historyData.value.forEach((item, index) => {
        item.id = index;
      });
    }
  } catch (error) {
    displayErrorMessage("Sorry, the history details cannot be found.");
    historyData.value = [];
  }
  dataLoading.value = false;
};
const cancelClick = () => {
  showModal.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showModal).value = $event)),
    title: "Signable Document History",
    height: "500px",
    width: _unref(ModalWidth).Medium,
    onCancel: cancelClick
  }, {
    "non-scrollable-content": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(GridBase, {
          "data-source": historyData.value,
          "id-column-name": "id",
          customColumnSlots: ['dateCell'],
          wordWrapEnabled: true,
          loading: dataLoading.value
        }, {
          columns: _withCtx(() => [
            _createVNode(_unref(DxColumn), {
              "data-field": "date",
              caption: "Date/Time",
              "hiding-priority": 4,
              "cell-template": "dateCell",
              width: "150px"
            }),
            _createVNode(_unref(DxColumn), {
              "data-field": "event",
              caption: "Event",
              "hiding-priority": 5
            })
          ]),
          dateCellData: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(formatDate)(data.date, true)), 1)
          ]),
          _: 1
        }, 8, ["data-source", "loading"])
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Close',
          onClick: () => {
            cancelClick();
          },
        }
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["modelValue", "width"]))
}
}

})